<template>
  <div class="i-base-error-card">
    <div class="logo">
      <a @click="emit('clickedLogo')"
        ><img
          :src="logo"
          alt="JobTest.org"
          class="logo-img"
        />
      </a>
    </div>

    <div
      class="text"
      v-html="props.errorMessageOneHTML"
    ></div>

    <div
      class="text"
      v-html="props.errorMessageTwoHTML"
    ></div>

    <div>
      <iBaseButton
        class="cta"
        :text="props.buttonText"
        :icon-url="iconUpArrowBlack"
        @clicked="emit('clickedButton')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import logo from "@/assets/logo/logo-dark.svg"
import iconUpArrowBlack from "@/assets/icons/icon-up-arrow-black.svg"

import iBaseButton from "@/components/base/BaseButton.vue"

// PROPS

const props = defineProps({
  buttonText: {
    type: String,
    default: "Back to Jobtest.org"
  },
  errorMessageOneHTML: {
    type: String,
    default: `<p>There was an error on our end. Please contact us at <strong><a href="mailto:support@jobtest.org">support@jobtest.org</a></strong> with the same email address you used when completing your test to assist you.</p>`
  },
  errorMessageTwoHTML: {
    type: String,
    default: `<p><strong>Thank you for your understanding!</strong></p>`
  }
})

// EMITS

const emit = defineEmits(["clickedLogo", "clickedButton"])
</script>

<style scoped lang="scss">
.i-base-error-card {
  text-align: center;

  @include card($shadow: true, $padding: true);

  .logo {
    margin-bottom: 24px;

    a:hover {
      cursor: pointer;
    }

    .logo-img {
      width: 160px;
    }
  }

  .text {
    margin-bottom: 20px;
  }

  .cta {
    margin: 32px auto 0;
  }
}
</style>
